import { createMemo } from 'solid-js';
import { useAuthenticatedUser } from '../../contexts/AuthContext';
import { formatCurrency } from '../../utils/currency';

export const TerminalHeader = () => {
	const { user } = useAuthenticatedUser();

	const subtitle = createMemo(() => {
		return user()?.name || 'UNAUTHENTICATED';
	});
	const statusText = createMemo(() => {
		return formatCurrency(user()?.bankroll || 0);
	});

	return (
		<div class="border-deep-gray mb-6 w-full">
			<div class="p-2">
				<div class="flex justify-between">
					<span class="truncate pr-2">█ SYSTEM: PANDEMIC POKER v0.01 (UNDER DEVELOPMENT)</span>
					<span class="animate-pulse">█</span>
				</div>
				<div class="flex justify-between uppercase">
					<span class="truncate pr-2">█ USER: {subtitle()}</span>
					<span>█</span>
				</div>
				<div class="flex justify-between uppercase">
					<span class="truncate pr-2">█ BANKROLL: {statusText()}</span>
					<span>█</span>
				</div>
			</div>
		</div>
	);
};
